import { type FC } from 'react';

interface StatCardProps {
  label: string;
  value: string | number;
  change?: string;
  changeType?: 'positive' | 'negative' | 'neutral';
  icon: string;
  variant?: 'default' | 'warning' | 'danger' | 'success';
  onClick?: () => void;
}

const variantStyles: Record<string, { border: string; iconBg: string; iconColor: string }> = {
  default: { border: 'border-l-primary-500', iconBg: 'bg-primary-50', iconColor: 'text-primary-600' },
  warning: { border: 'border-l-amber-500', iconBg: 'bg-amber-50', iconColor: 'text-amber-600' },
  danger: { border: 'border-l-red-500', iconBg: 'bg-red-50', iconColor: 'text-red-600' },
  success: { border: 'border-l-emerald-500', iconBg: 'bg-emerald-50', iconColor: 'text-emerald-600' },
};

const changeColors: Record<string, string> = {
  positive: 'text-emerald-600',
  negative: 'text-red-600',
  neutral: 'text-foreground-500',
};

const StatCard: FC<StatCardProps> = ({ label, value, change, changeType = 'neutral', icon, variant = 'default', onClick }) => {
  const styles = variantStyles[variant];

  return (
    <div
      onClick={onClick}
      className={`bg-background-50 border border-background-200/70 border-l-4 ${styles.border} rounded-lg p-4 flex items-start gap-3 transition-all duration-200 hover:bg-background-100 ${onClick ? 'cursor-pointer' : ''}`}
    >
      <div className={`w-10 h-10 rounded-lg ${styles.iconBg} flex items-center justify-center flex-shrink-0`}>
        <i className={`${icon} ${styles.iconColor} text-lg`}></i>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs text-foreground-500 font-medium whitespace-nowrap">{label}</p>
        <p className="text-lg font-semibold text-foreground-900 mt-0.5 whitespace-nowrap">{value}</p>
        {change && (
          <p className={`text-xs mt-0.5 font-medium ${changeColors[changeType]} whitespace-nowrap`}>{change}</p>
        )}
      </div>
    </div>
  );
};

export default StatCard;